<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-12">
          <h6 class="h2 text-white d-inline-block mb-0">Crear Cotización</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="row justify-content-center">
        <pre-select-form v-show="!canCreate" :subtitle="subtitle" @selected="fetchBaseData" />

        <quotation-form
          v-if="canCreate"
          :campaign="campaign"
          :quotation-id="quotationId"
          :producer="producer"
          :projection="projection"
          :user-name="userData.name"
          @save="saveQuotation"
          @confirm="confirmQuotation"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PreSelectForm from '../../components/ModelSelects/PreSelectProducerCampaign';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import QuotationForm from './Forms/QuotationForm';
import swal from 'sweetalert2';

export default {
  components: {
    RouteBreadCrumb,
    QuotationForm,
    PreSelectForm,
  },

  data() {
    return {
      subtitle: 'Elija la campaña y productor, y pulse en SELECCIONAR para realizar el pedido',
      projection: null,
      userData: null,
      producer: null,
      campaign: null,
      quotationId: 0,
      quotationCreated: false,
    };
  },

  computed: {
    canCreate() {
      return this.campaign && this.producer;
    },
  },

  created() {
    this.userData = this.$auth.user().data;
    const projectionId = this.$route.query.projection;
    const producerId = this.$route.query.producer;
    const campaignId = this.$route.query.campaign;
    if (producerId && campaignId) {
      this.fetchBaseData(producerId, campaignId);
    }
    if (projectionId) {
      this.fetchOptionalData(projectionId);
    }
  },

  methods: {
    fetchBaseData(producerId, campaignId) {
      this.fetchProducer(producerId);
      this.fetchCampaign(campaignId);
    },

    fetchOptionalData(projectionId) {
      if (projectionId) {
        this.fetchProjection(projectionId);
      }
    },

    fetchProducer(id) {
      this.$services
        .resource('producers')
        .show(id, { include: ['distributor.seller'] })
        .then((res) => res.data.data)
        .then((producer) => (this.producer = producer));
    },

    fetchCampaign(id) {
      this.$services
        .resource('campaigns')
        .show(id, { include: ['crops', 'articles'] })
        .then((res) => res.data.data)
        .then((campaign) => (this.campaign = campaign));
    },

    fetchProjection(id) {
      this.$services
        .resource('projections')
        .show(id)
        .then((res) => res.data.data)
        .then((projection) => {
          this.projection = projection;
        });
    },

    saveQuotation(quotation) {
      if (!this.quotationCreated) {
        this.createQuotation(quotation);
      } else {
        this.updateQuotation(quotation);
      }
    },

    createQuotation(quotation) {
      quotation.producerId = this.producer.id;
      quotation.campaignId = this.campaign.id;
      quotation.projectionId = this.projection ? this.projection.id : null;
      this.$services
        .resource('quotations')
        .create(quotation)
        .then((res) => res.data.data)
        .then((model) => {
          quotation.state = model.state;
          quotation.code = model.code;
          this.quotationId = model.id;
          this.quotationCreated = true;
        });
    },

    updateQuotation(quotation) {
      this.$services
        .resource('quotations')
        .update(this.quotationId, quotation)
        .then((res) => res)
        .catch((model) => {
          this.quotation = null;
          this.isDataLoaded = false;
          this.fetchQuotation();
        });
    },

    confirmQuotation() {
      //redirigir al resumen de la cotización
      this.$services
        .resource('quotations')
        .confirm(this.quotationId)
        .then(() => {
          const canShowQuotations = this.$can('show', 'quotations');

          swal({
            title: 'Listo!',
            text: 'La cotización fue confirmada.',
            type: 'success',
            showCancelButton: true,
            buttonsStyling: false,
            confirmButtonText: canShowQuotations ? 'Ver Cotización' : 'Listado Cotizaciones',
            cancelButtonText: 'Ver Proyección',
            confirmButtonClass: 'btn btn-secondary',
            cancelButtonClass: 'btn btn-success',
          }).then((choice) => {
            if (choice.value) {
              if (canShowQuotations) {
                this.$router.push({ name: 'QuotationShow', params: { id: this.quotationId } });
              } else {
                this.$router.push({ name: 'QuotationsList' });
              }
            } else {
              this.$router.push({ name: 'ProjectionShow', params: { id: this.projection.id } });
            }
          });
        })
        .catch(() => {
          // this.serverErrors = errors
        });
    },

    reset() {
      this.quotationId = 0;
      this.campaign = null;
      this.producer = null;
      this.projection = null;
    },
  },
};
</script>
